import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from '../../../services/auth/authentication.service';
import {RouteParamnames} from '../../../route-param-names.enum';
import {Routenames} from '../../../routenames';
import {CodaltComponent} from '../../codalt/codalt.component';
import {Title} from '@angular/platform-browser';
import {LocalStorage} from '../../../utils/storage';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss']
})
export class LogoutComponent extends CodaltComponent {

    constructor(private authService: AuthenticationService,
                private router: Router,
                private route: ActivatedRoute,
                private title: Title) {
        super();
    }

    ngOnInit(): void {
        this.title.setTitle('Uitloggen - TSNed App');
        if(LocalStorage.getParentUserToken()) {
            this.authService.switchToParent();
        } else {
            this.subscriptions.add(this.authService.logout().subscribe(() => {
                this.doNavigate();
            }, () => {
                this.doNavigate();
            }));
        }
    }

    private doNavigate() {
        const via = this.route.snapshot.queryParams[RouteParamnames.via];
        if (!!via) {
            this.router.navigate(Array.isArray(via) ? via : [via], {replaceUrl: true});
        } else {
            this.router.navigate([Routenames.Home], {replaceUrl: true});
        }
    }
}
